import styled from 'styled-components';
import TrueImpactText, {
  TrueImpactTextProps,
  textSelectionNone,
} from '../base/TrueImpactText';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';

interface TrueImpactCapsuleProps extends Omit<TrueImpactTextProps, 'variant'> {
  variant?: TrueImpactTextProps['variant'];
  textSelection?: boolean;
  backgroundColor?: keyof typeof COLORS;
}

const TrueImpactCapsule = styled(TrueImpactText).attrs<TrueImpactCapsuleProps>(
  props => ({
    variant: props.variant || 'body-bold',
  }),
)<TrueImpactCapsuleProps>`
  border-radius: 24px;
  ${({ textSelection }) => (textSelection === true ? '' : textSelectionNone)}
  background-color: ${({ backgroundColor }) =>
    COLORS[backgroundColor || 'grayLightest']};
  display: inline-block;
  padding: ${SPACERS.tiny} ${SPACERS.small};
`;

export default TrueImpactCapsule;
